<template>
  <div class="im-thumb">
    <div class="im-search-row">
      <div class="im-search">
        <span class="im-search-icon">
          <icon name="search"/>
        </span>
        <input
          ref="input"
          v-model="searchQuery"
          type="search"
          aria-label="Search"
          placeholder="Search"
          @keydown.enter.stop="changeQueryValue">
        <button
          v-show="searchQuery != ''"
          type="button"
          class="im-search-clear"
          aria-label="Clear search"
          title="Clear search"
          @click="clearValue($event)">
          <icon name="close-icon"/>
        </button>
      </div>
      <span
        v-if="searchQuery"
        class="im-search-results">Results for “{{ searchQuery }}”</span>
    </div>

    <div
      :id="galleryImages == 'gallery' ? 'gallery-images':'stock-images'"
      class="thumbnail-box-conatiner">
      <div
        v-show="loader"
        class="loader-anchor">
        <Spinner
          :speed="1"
          size="huge"
          message="Loading..."
          class="inner-Loader"/>
      </div>
      <div
        v-if="getMyGalleryFilter.length"
        :id="getMasonryId"
        class="image-container">
        <div
          v-for="(image, i) in getMyGalleryFilter"
          :key="image.Id || i"
          class="image-wrapper">
          <div
            class="image-item"
            :class="{ 'is-selected': imageData.Id == image.Id }">
            <div
              v-if="galleryImages == 'gallery'"
              class="image-delete-button"
              :class="{ 'is-visible': imageData.Id == image.Id }"
              @click.stop="deleteImageFromMyGallery(image.Id)">
              <icon name = "trash"/>
            </div>
            <img
              ref="galleryVariable"
              :data-name="image.Name"
              :src="image.ImageThumbnailPathV2 && (image.ImageThumbnailPathV2.trim().endsWith('.svg')?image.DefaultImageUrl:(image.ImageThumbnailPathV2 ? image.ImageThumbnailPathV2:image.ImageThumbnailPathV2))"
              :id="i"
              :style="thumbStyle(image)"
              alt=""
              @click.stop="imageSelected(image)">
          </div>
        </div>
      </div>
      <div
        v-else-if="resultsReady && !loader"
        class="im-empty">
        No Results Matched
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/EventBus';
import Spinner from 'vue-simple-spinner';

export default {
  name:       'ThumbnailBox',
  components: { Spinner },
  props:      {
    ImageTitle:    String,
    imageData:     Object,
    images:        { Object, Array },
    galleryImages: { type: String, default: 'null' },
    loader:        { default: false },
  },
  data() {
    return {
      searchQuery:  '',
      isFocused:    false,
      isFocusedOut: false,
      resultsReady: false,
    };
  },

  computed: {
    getMasonryId() {
      return this.galleryImages == 'gallery' ? 'gallery-masonry' : 'stock-masonry';
    },

    getMyGalleryFilter() {
      if (this.galleryImages == 'gallery') {
        if (this.searchQuery) {
          return this.images.filter(imageObject => imageObject.Name.toLowerCase().includes(this.searchQuery.toLowerCase()));
        }
        return this.images;
      }

      return this.images;
    },
  },

  watch: {
    loader(isLoading, wasLoading) {
      if (wasLoading && !isLoading) this.resultsReady = true;
    },
  },
  methods: {
    changeQueryValue(event) {
      this.searchQuery = event.target.value;
      if (this.galleryImages != 'gallery') {
        this.$emit('searchStockPhotos', this.searchQuery);
      }
    },

    imageSelected(image) {
      this.$store.commit('activeProduct/updateTotalUploadFiles', 1);
      this.$store.commit('activeProduct/updateCurrentUploadFile', 0);
      EventBus.$emit('onImageSelected', image);
    },
    deleteImageFromMyGallery(id) {
      EventBus.$emit('ondeleteImageFromMyGallary', id);
    },
    clearValue() {
      this.searchQuery       = '';
      this.isFocused         = false;
      this.$refs.input.value = '';
      this.$emit('resetStockPhotosAfterSearch');
    },
    thumbStyle(image) {
      const width  = Number(image.ImageThumbnailPathV2Width);
      const height = Number(image.ImageThumbnailPathV2Height);
      if (!(width > 0 && height > 0)) {
        return { backgroundColor: '#efefef' };
      }
      return {
        backgroundColor: '#efefef',
        aspectRatio:     `${width} / ${height}`,
      };
    },
  },
};

</script>
<style lang="scss" scoped>
.im-thumb {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.im-search-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.im-search {
  width: 100%;
  max-width: 100%;
  height: 38px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 8px 0 12px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  box-shadow: inset 0 0 0 1px #E7E9ED;
}

.im-search:focus-within {
  box-shadow: inset 0 0 0 1.5px #1570EF, 0 0 0 3px rgba(21, 112, 239, 0.15);
}

.im-search-icon,
.im-search-icon .icon,
.im-search-clear .icon {
  display: flex;
  min-width: 0;
  min-height: 0;
  flex-shrink: 0;
  color: #5E6573;
}

.im-search-icon .icon svg,
.im-search-clear .icon svg {
  width: 16px;
  height: 16px;
}

.im-search-clear .icon svg {
  width: 14px;
  height: 14px;
}

.im-search input {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  font-family: inherit;
  font-size: 13.5px;
  color: #14161B;
  box-shadow: none;
}

.im-search input::-webkit-search-cancel-button {
  display: none;
}

.im-search-clear {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  padding: 0;
  cursor: pointer;
  background: transparent;
  color: #3D4350;
}

.im-search kbd {
  font-family: 'Geist Mono', ui-monospace, 'SF Mono', Menlo, monospace;
  font-size: 10.5px;
  color: #5E6573;
  background: #F3F4F6;
  border-radius: 5px;
  padding: 2px 6px;
}

.im-search-results {
  font-size: 12.5px;
  color: #5E6573;
}

.thumbnail-box-conatiner {
  position: relative;
  flex: 1 1 auto;
  min-height: 240px;
  overflow: auto;
  padding: 4px;
}

.image-container {
  columns: 4;
  column-gap: 10px;
}

.image-wrapper {
  break-inside: avoid;
  width: 100%;
  margin-bottom: 10px;
}

.image-item {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  background: #efefef;
  cursor: pointer;
}

.image-item:hover .image-delete-button,
.image-delete-button.is-visible {
  opacity: 1;
}

.image-item.is-selected {
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px #1570EF;
}

.image-delete-button {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 6px;
  opacity: 0;
  cursor: pointer;
}

.image-item img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 10px;
}

.im-empty {
  padding: 32px 0;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #D92D20;
}

.loader-anchor {
  position: sticky;
  top: 0;
  z-index: 56;
  height: 0;
  pointer-events: none;
}

.inner-Loader {
  position: absolute;
  top: 210px;
  left: 40px;
  width: calc(100% - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 56;
  pointer-events: none;

  .vue-simple-spinner-text {
    color: #52A7E1 !important;
  }
}

@media screen and (max-width: 980px) {
  .image-container {
    columns: 3;
  }
}

@media screen and (max-width: 720px) {
  .image-container {
    columns: 2;
  }
}

@media screen and (max-width: 460px) {
  .image-container {
    columns: 1;
  }
}
</style>
